'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _urls = require('../../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DeskPopup = require('../../../../components/DeskPopup/DeskPopup');

var _DeskPopup2 = _interopRequireDefault(_DeskPopup);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _FormattedMessage = require('../../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _Support = require('./Support.scss');

var _Support2 = _interopRequireDefault(_Support);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Support = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(Support, _PureComponent);

    function Support() {
        (0, _classCallCheck3.default)(this, Support);
        return (0, _possibleConstructorReturn3.default)(this, (Support.__proto__ || (0, _getPrototypeOf2.default)(Support)).apply(this, arguments));
    }

    (0, _createClass3.default)(Support, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                email = _props.email,
                fullName = _props.fullName,
                openHealthcheckModal = _props.openHealthcheckModal,
                year = _props.year;


            return (0, _jsx3.default)('div', {
                className: _Support2.default.support
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'company'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/about'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'about'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                target: '_blank',
                to: 'https://careers.jobscore.com/careers/liveauctioneers',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'careers'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                target: '_blank',
                to: baseUrl + '/news/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_central_news'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'support_center'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'contact_us'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_DeskPopup2.default, {
                useLink: true,
                textId: 'deskpopup.footer'
            }))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'winning'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/how-it-works'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'how_auctions_work'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getAllUpcomingAuctionsUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_calendar'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_house_directory'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/find-auctions-near-me'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auctions_near_you'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_result_search'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/mobile'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'mobile'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'selling'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/features'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'why_sell'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/seller-testimonials'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'seller_testimonials'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/pages/sell/'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'become_a_seller'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                route: true,
                to: '/consignments'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'consign_an_item'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_link2.default, {
                target: '_blank',
                to: classicBaseUrl + '/user/login.html?url=/auctioneers/',
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auctioneer_sign_in'
            }))))))), (0, _jsx3.default)('div', {
                className: _Support2.default['container-using']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'using'
            }), ': \xA0', (0, _jsx3.default)('span', {
                className: _Support2.default['new-site']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'the_new_liveauctioneers_site'
            })), ' ', '\xA0', (0, _jsx3.default)(_link2.default, {
                to: classicBaseUrl,
                className: _Support2.default['classic-link'],
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'classic_site'
            }))), (0, _jsx3.default)('div', {
                className: _Support2.default['social-icons']
            }, void 0, (0, _jsx3.default)('a', {
                className: _Support2.default.icon,
                alt: 'Email',
                href: (0, _urls.getDeskSupportEmail)(fullName, email),
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                icon: ['fas', 'envelope']
            })), (0, _jsx3.default)('a', {
                className: _Support2.default.icon,
                alt: 'Twitter',
                href: 'https://twitter.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                icon: ['fab', 'twitter']
            })), (0, _jsx3.default)('a', {
                className: _Support2.default.icon,
                alt: 'Facebook',
                href: 'https://www.facebook.com/LiveAuctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                icon: ['fab', 'facebook-f']
            })), (0, _jsx3.default)('a', {
                className: _Support2.default.icon,
                alt: 'Pinterest',
                href: 'https://www.pinterest.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                icon: ['fab', 'pinterest']
            }))), (0, _jsx3.default)('div', {
                className: _Support2.default['container-copyright']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.copyright
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xA9'), ' ', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'copyright',
                values: { year: year }
            }), (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getCookiePolicyUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'cookie_policy'
            })), (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getTermsAndConditionsUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'terms_and_conditions'
            })), (0, _jsx3.default)(_link2.default, {
                route: true,
                to: (0, _urls.getPrivacyUrl)()
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'privacy_policy'
            })), (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                className: _Support2.default.health,
                icon: ['fas', 'tachometer-alt'],
                onClick: openHealthcheckModal
            })), (0, _jsx3.default)('div', {
                className: _Support2.default.sitemap
            }, void 0, (0, _jsx3.default)('span', {
                className: _Support2.default['bold-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'sitemap'
            }), ':'), (0, _jsx3.default)(_link2.default, {
                to: 'https://www.liveauctioneers.com/browse/archive/page1',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'past_auctions'
            })), (0, _jsx3.default)(_link2.default, {
                to: 'https://www.liveauctioneers.com/browse/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'upcoming_auctions'
            })), (0, _jsx3.default)(_link2.default, {
                to: 'https://www.liveauctioneers.com/search_auctioneers.html',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auctioneer_directory'
            })))));
        }
    }]);
    return Support;
}(_react.PureComponent), _class.defaultProps = {
    email: '',
    fullName: ''
}, _temp);
exports.default = Support;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Support/Support.js
// module id = s0Az
// module chunks = 60